/**
 * Sedona Summit Sold Out Button
 * @description Changes the "Enroll Now" button to "Sold Out" and disables it.
 * @returns {void}
 */
function sedonaSummitSoldOut() {
  const cartId = "43298690367679";

  // Common styles for all buttons
  const commonStyles = {
    opacity: "0.8",
    cursor: "not-allowed",
    pointerEvents: "none",
  };

  // Specific styles for Malibu button
  const malibuStyles = {
    backgroundColor: "#222",
    border: "none",
    textTransform: "uppercase",
    ...commonStyles,
  };

  // Button selectors
  const selectors = {
    sedona: `body.template-page-ffs-summit-sed a[href^='/cart/${cartId}']`,
    homePage: `body.template-index a[href^='/cart/${cartId}']`,
    malibu: `body.template-page-ffs-summit-mal .ffs-ss9-section a[href^='/pages/sedona-summit']`,
  };

  // Get all buttons
  const sedonaAndHomePageBtns = document.querySelectorAll(
    `${selectors.sedona}, ${selectors.homePage}`
  );
  const malibuBtn = document.querySelector(selectors.malibu);

  // Exit if no buttons found
  if (!sedonaAndHomePageBtns.length && !malibuBtn) return;

  // Apply common button attributes and styles
  function applyButtonChanges(button) {
    button.textContent = "Sold Out";
    button.href = "javascript:void(0)";
    button.setAttribute("aria-disabled", "true");
    button.setAttribute("disabled", "true");
    Object.assign(button.style, commonStyles);
  }

  // Process Sedona and Homepage buttons
  sedonaAndHomePageBtns.forEach(applyButtonChanges);

  // Process Malibu button with special styles
  if (malibuBtn) {
    applyButtonChanges(malibuBtn);
    Object.assign(malibuBtn.style, malibuStyles);
  }
}

/**
 * Redirect Main Page to Malibu Summit
 * @description Redirects the main page to the Malibu Summit page.
 * @returns {void}
 */
function redirectMainPageToMalibu() {
  const homePageBody = document.querySelector("body.template-index");

  if (!homePageBody) return;

  const malibuPageUrl = "/pages/malibu-summit";
  const academyPageUrl = "/pages/academy";

  // Check if the current URL is already the Malibu Summit page to avoid unnecessary redirects
  // if (window.location.pathname !== malibuPageUrl) {
  if (window.location.pathname !== academyPageUrl) {
    window.location.href = academyPageUrl;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  sedonaSummitSoldOut();
  redirectMainPageToMalibu();
});
